import styles from "./NavBar.module.css";
import FleekIcon from "../../asset/icons/FleekIcon.png"
import HumanIcon from "../../asset/icons/Human.png"
import React,{ useState ,useEffect }  from "react";
import { Link } from "react-router-dom";
import cx from 'classnames';
import { CoinNWallet } from "../../components";
import  Api from "../../utils/Api/Api";


export const NavBar = ({hideNavOnMobile , fixedNavBar = true, image, isLoggedIn})=>{
    const [userDetails,setUserDetails] = useState({
        avatar_url:''
    })

    useEffect(()=>{
        const fetchUserDetails = async ()=>{
            try {
                let { data: { avatar_url } = {} } = await Api.GetUserDetails();
     
                setUserDetails({
                    avatar_url: avatar_url || ''
                })
            }
            catch(err) {
                // setError(true);
            }
            // setLoading(false)
        }
        if(isLoggedIn)
        fetchUserDetails();
    },[isLoggedIn])

    if(!image) {
        image = userDetails.avatar_url
    }
    const NavBarStyle = ()=>{
        if(hideNavOnMobile){
            return cx(styles.NavBar , styles.hideOnMobile)
        }
        if(fixedNavBar){
            return cx(styles.NavBar , styles.fixedNavBar)
        }
        return styles.NavBar
    }
    return(
        <>
            <div className={styles.navContent}>
                <div className={NavBarStyle()}>
                    <Link className={styles.fleekTitleContainer} to={"/marketplace"}>
                        <img className={styles.fleekicon} src={FleekIcon} alt="FleekIcon" />
                        <p className={styles.fleektitle}>fleek</p>
                    </Link>
                    {/* <p className={styles.fleektitle}>Fleek</p> */}
                    <div className={styles.rightContent}>
                        {isLoggedIn && <CoinNWallet isLoggedIn={isLoggedIn} />}
                        <Link style={{textDecoration: 'none'}} to={isLoggedIn ? '/account' : '/login'} className={styles.hideInMob}>
                            {
                                image?
                                <img className={styles.avatar} src={image} alt="Avatar"/>
                                :
                                <div className={styles.iconContainer}>
                                    <img className={styles.icon} src={HumanIcon} alt="HumanIcon" />
                                </div>
                            }
                            
                        </Link>
                    </div>
                </div>
            </div>
            {
                fixedNavBar && !hideNavOnMobile && <div className={styles.spacer}>

                </div>
            }
        </>
        
    )
}